// Google Maps is fetched by the first controller that needs it, not by every
// page: a visitor who refused cookies on a page without an address field or a
// map gets no request to Google. ActiveAdmin still includes it itself.
let googleMaps

export function loadGoogleMaps () {
  googleMaps ||= new Promise((resolve, reject) => {
    if (window.google?.maps) {
      resolve(window.google.maps)
      return
    }

    const key = document.querySelector('meta[name="google-maps-api-key"]').content
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${key}`
    script.async = true
    script.onload = () => resolve(window.google.maps)
    script.onerror = (error) => {
      googleMaps = null
      script.remove()
      reject(error)
    }
    document.head.append(script)
  })

  return googleMaps
}
